/**
 * `GET /admin/audit-logs` - spec 12's audit viewer (FR-8.5, AC7).
 *
 * Read-only: `audit_logs` is append-only and this is the only read of it.
 *
 * `action` and `entity_type` have no CHECK constraint in the schema, so the
 * filter options come back with every page (`entity_types`, `actions`) rather
 * than being hardcoded here - a hardcoded list would stop offering a value the
 * first time a service wrote a new one.
 */

import { request } from "./client";
import type { Page } from "./types";

export type AuditActor = {
  id: string;
  full_name: string;
};

export type AuditLogEntry = {
  /** BIGINT identity - the schema's one non-UUID primary key. */
  id: number;
  /** Null when the admin who made the change has since been removed. */
  actor: AuditActor | null;
  action: string;
  entity_type: string;
  entity_id: string | null;
  before_state: Record<string, unknown> | null;
  after_state: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
};

export type AuditLogPage = Page<AuditLogEntry> & {
  entity_types: string[];
  actions: string[];
};

export type AuditFilters = {
  actor_user_id?: string;
  entity_type?: string;
  entity_id?: string;
  action?: string;
  from_date?: string;
  to_date?: string;
  limit?: number;
  offset?: number;
};

export function fetchAuditLogs(filters: AuditFilters): Promise<AuditLogPage> {
  return request<AuditLogPage>("/admin/audit-logs", { query: { ...filters } });
}
